export const deliveredShipmentReconciliationCollectionGuard =
  'GET /shipment-reconciliations/delivered';
export const pickedUpShipmentReconciliationCollectionGuard =
  'GET /shipment-reconciliations/picked-up';
export const employeesShipmentReconciliationCollectionGuard =
  'GET /shipment-reconciliations/employees';

export const updateShipmentReconciliationCollectionGuard =
  'POST /shipment-reconciliations';
